import { useState, useEffect } from 'react';
export const useFetchData = (url) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true; // предотвращает обновление стейта после размонтирования компонента

    const fetchData = async () => {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        if (isMounted) setData(result);
      } catch (err) {
        if (isMounted) setError('Error loading data');
        console.error('Error loading data:', err);
      }
    };

    fetchData();

    return () => { isMounted = false }; // cleanup
  }, [url]);

  return { data, error };
};
